var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupsCompetitionUpdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20535 23.041L5.46451 20.5753L11.5951 17.2876L11.9407 13.9999L2.14721 4.95885L2.49275 1.67118H7.4514L7.62417 0.0273438H15.0621H22.5001L22.3273 1.67118H27.286L26.9404 4.95885L15.2465 13.9999L14.9009 17.2876L20.3404 20.5753L20.0813 23.041H12.6433H5.20535ZM8.10507 3.31501H4.7993L4.71292 4.13693L7.75952 6.60268L8.10507 3.31501ZM21.3281 3.31501H24.6339L24.5475 4.13693L20.9826 6.60268L21.3281 3.31501Z",
    fill: "#FFB800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2846 1.79248L15.5669 1.79248L14.5664 11.3464L12.96 11.3464L13.7209 4.08935H13.7068L12.4527 5.27302H12.4386L12.6218 3.52571L14.2846 1.79248Z",
    fill: "#161C31"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7513_477874",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 5,
    width: 31,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01379 23.589V28.5205H39.6984V5.50684L29.6801 5.50685L17.9861 14.5479L17.6406 17.8356L23.0801 21.1233L15.383 23.589H9.01379ZM9.01379 5.94847V5.50684H10.672L10.4992 7.15068L9.01379 5.94847ZM9.01379 9.31669L14.6804 14.5479L14.3348 17.8356L9.01379 20.6891V9.31669Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7513_477874)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3273 28.5205L17.5865 26.0548L23.7171 22.7671L24.0626 19.4794L14.2692 10.4383L14.6147 7.15067H19.5733L19.7461 5.50684H27.1841H34.6221L34.4493 7.15067H39.4079L39.0624 10.4383L27.3684 19.4794L27.0229 22.7671L32.4624 26.0548L32.2032 28.5205H24.7653H17.3273ZM20.227 8.79451H16.9213L16.8349 9.61642L19.8815 12.0822L20.227 8.79451ZM33.4501 8.79451H36.7558L36.6695 9.61642L33.1045 12.0822L33.4501 8.79451Z",
    fill: "#D9D7CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8032 16.8259L23.9864 15.0645C24.0991 14.0077 24.4796 13.5286 25.4378 12.5703L26.4101 11.6121C26.9597 11.0626 27.1147 10.7526 27.1851 9.96346L27.2697 9.17435C27.326 8.6107 27.0301 8.4557 26.706 8.4557C26.3678 8.4557 26.086 8.6107 26.0296 9.16026L25.9028 10.4003L24.4373 10.4003L24.5782 9.06162C24.7051 7.82159 25.4519 7.1593 26.8047 7.1593C28.3406 7.1593 28.9888 7.90614 28.8338 9.31526L28.7352 10.2453C28.6224 11.2458 28.3829 11.6685 27.4669 12.5844L26.3537 13.6695C25.9028 14.1204 25.5787 14.4445 25.5083 15.1209L25.466 15.5154L28.1151 15.5154L27.9742 16.8259L23.8032 16.8259Z",
    fill: "#161C31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupsCompetitionUpdated);
export default __webpack_public_path__ + "static/media/cups-competition-updated.d73aea854dd1ef63d95ad17002c2fcff.svg";
export { ForwardRef as ReactComponent };